const MaterialUILogo = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="skill-icon"
    >
      <path
        d="M0.200195 68.5999V13.3999L48.0002 40.9999V59.3999L16.1002 40.9999V77.7999L0.200195 68.5999ZM48.0002 40.9999L95.9002 13.3999V68.6999L64.0002 86.9999L48.0002 77.7999L80.0002 59.3999V40.9999L48.0002 59.3999V40.9999Z"
        fill="#00E96C"
      />
      <path
        d="M48 77.7999V96.1999L80 114.6V96.1999L48 77.7999ZM80 114.6L127.8 86.9999V50.1999L111.8 59.3999V77.7999L80 96.1999V114.6ZM111.9 40.9999V22.5999L127.9 13.3999V31.7999L111.9 40.9999Z"
        fill="#00E96C"
      />
    </svg>
  );
};

export default MaterialUILogo;
